"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var channelManagementRouter = {
  type: 1,
  path: "/sms-channel-management",
  component: _layout.default,
  redirect: '/table/sms-channel',
  name: '',
  meta: {
    title: "channelManagement",
    icon: "g-channel"
  },
  children: [{
    type: 2,
    path: "pay-channel-group-management",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-channel-management/pay-channel-group-management"));
      });
    },
    name: "payChannelGroup:view",
    meta: {
      title: "payChannelGroup"
    },
    children: [{
      path: "add",
      name: "payChannelGroup:add",
      hidden: true
    }, {
      path: "addCost",
      name: "payChannelGroup:addCost",
      hidden: true
    }, {
      path: "delete",
      name: "payChannelGroup:delete",
      hidden: true
    }, {
      path: "update",
      name: "payChannelGroup:update",
      hidden: true
    }]
  }, {
    type: 2,
    path: "pay-channel-group-cost-management",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-channel-management/pay-channel-group-cost-management"));
      });
    },
    name: "payChannelGroupCost:view",
    meta: {
      title: "payChannelGroupCost",
      noCache: true
    },
    hidden: true,
    props: true,
    children: [{
      path: "add",
      name: "payChannelGroupCost:add",
      hidden: true
    }, {
      path: "delete",
      name: "payChannelGroupCost:delete",
      hidden: true
    }, {
      path: "update",
      name: "payChannelGroupCost:update",
      hidden: true
    }]
  }, {
    type: 2,
    path: "pay-channel-group-cost-member-management",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-channel-management/pay-channel-group-cost-member-management"));
      });
    },
    name: "payChannelGroupCostMember:view",
    meta: {
      title: "payChannelGroupCostMember",
      noCache: true
    },
    hidden: true,
    props: true,
    children: [{
      path: "add",
      name: "payChannelGroupCostMember:add",
      hidden: true
    }, {
      path: "delete",
      name: "payChannelGroupCostMember:delete",
      hidden: true
    }, {
      path: "update",
      name: "payChannelGroupCostMember:update",
      hidden: true
    }]
  }, {
    type: 2,
    path: "pay-channel",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-channel-management/pay-channel"));
      });
    },
    name: "payChannel:view",
    meta: {
      title: "payChannel"
    },
    children: [{
      path: "add",
      name: "payChannel:add",
      hidden: true
    }, {
      path: "delete",
      name: "payChannel:delete",
      hidden: true
    }, {
      path: "update",
      name: "payChannel:update",
      hidden: true
    }]
  }, {
    path: '/pay-channel-cost',
    name: 'payChannelCost:view',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-channel-management/pay-channel-cost'));
      });
    },
    hidden: true,
    props: true,
    meta: {
      title: 'payChannelCost' // noCache:true

    }
  }, {
    type: 2,
    path: "currency-exchange-rate",
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require("@/views/sms-channel-management/currency-exchange-rate"));
      });
    },
    name: "currencyExchangeRate:view",
    meta: {
      title: "currencyExchangeRate"
    },
    children: [{
      path: "add",
      name: "currencyExchangeRate:add",
      hidden: true
    }, {
      path: "delete",
      name: "currencyExchangeRate:delete",
      hidden: true
    }, {
      path: "update",
      name: "currencyExchangeRate:update",
      hidden: true
    }, {
      path: "export",
      name: "currencyExchangeRate:export",
      hidden: true
    }]
  }]
};
var _default = channelManagementRouter;
exports.default = _default;